import axios from 'axios'

const AWS_API_GW = typeof window !== 'undefined' ? window.config.AWS_API_GW : ''
const AWS_DISTANCE_MATRIX_GW = typeof window !== 'undefined' ? window.config.AWS_DISTANCE_MATRIX_GW : ''
export const postRequest = (body) => axios.post(AWS_API_GW, { body })
export const fetchNearestBranches = (body) => axios.post(AWS_DISTANCE_MATRIX_GW, body)



// WEBPACK FOOTER //
// ./src/helpers/LambdaHelper.js